import Vue from "vue";
import VueRouter from "vue-router";
import {navigationGuards} from "@/common/navigation/navigationGuards";
import {navigationPaths} from "@/common/navigation/navigationPaths";
import {enumDef} from "@/common/enumDefs";

const
// General
    DashboardLayout = resolve => require(["@/views/Layout/DashboardLayout"], resolve),
    CompanyDisclosure = resolve => require(["@/views/CompanyDisclosure"], resolve),
    AccessDenied = resolve => require(["@/views/AccessDenied"], resolve),

    // Login
    Login = resolve => require(["@/views/login"], resolve),
    RestPasswords = resolve => require(["@/views/user/restPasswords"], resolve),
    SendEmail = resolve => require(["@/views/user/SendEmail"], resolve),
    Redirect = resolve => require(["@/views/Redirect"], resolve),

    // Registration
    RegisterLayer = resolve => require(["@/views/start/register"], resolve),
    SignUpPageLanguage = resolve => require(["@/views/register/SignUpPageLanguage"], resolve),
    SignUpPageInvitation = resolve => require(["@/views/register/SignUpPageInvitation"], resolve),
    SignUpPageCompany = resolve => require(["@/views/register/SignUpPageCompany"], resolve),
    SignUpPageLegalData = resolve => require(["@/views/register/SignUpPageLegalData"], resolve),
    SignUpPageBankAccount = resolve => require(["@/views/register/SignUpPageBankAccount"], resolve),
    SignUpPageMasterUser = resolve => require(["@/views/register/SignUpPageMasterUser"], resolve),
    SignUpPageRepresentativeUser = resolve => require(["@/views/register/SignUpPageRepresentativeUser"], resolve),
    SignUpPageRepresentatives = resolve => require(["@/views/register/SignUpPageRepresentatives"], resolve),
    SignUpPageBeneficialOwners = resolve => require(["@/views/register/SignUpPageBeneficialOwners"], resolve),
    SignUpPagePassword = resolve => require(["@/views/register/SignUpPagePassword"], resolve),
    SignUpPageOverview = resolve => require(["@/views/register/SignUpPageOverview"], resolve),
    SignUpPageCompletion = resolve => require(["@/views/register/SignUpPageCompletion"], resolve),

    NormalUserActivation = resolve => require(["@/views/register/NormalUserActivation"], resolve),

    // After login
    Dashboard = resolve => require(["@/views/dashboard/dashboard"], resolve),

    // Seller
    DebtorManagement = resolve => require(["@/views/seller/debtorManagement/debtorManagement"], resolve),
    SellerSell = resolve => require(["@/views/seller/sell/sell"], resolve),
    SellerUpload = resolve => require(["@/views/seller/upload/upload"], resolve),
    SellerPutOption = resolve => require(["@/views/seller/putOption/putOption"], resolve),

    // Investor
    InvestorExchange = resolve => require(["@/views/investor/exchange/exchange"], resolve),
    InvestorPayments = resolve => require(["@/views/investor/payments/payments"], resolve),
    AllInvestments = resolve => require(["@/views/investor/allInvestments/allInvestments"], resolve),
    CustomRating = resolve => require(["@/views/investor/customRating/customRating"], resolve),

    // Debtor
    DebtorIpu = resolve => require(["@/views/debtor/debtorIpu"], resolve),

    // Admin
    UserProfile = resolve => require(["@/views/user/profile/Profile"], resolve),
    UserUsers = resolve => require(["@/views/user/users/users"], resolve),
    UserBankAccounts = resolve => require(["@/views/user/bankAccounts/BankAccounts"], resolve),
    UserInvoices = resolve => require(["@/views/user/invoices/invoices"], resolve),
    UserCompany = resolve => require(["@/views/user/company/company"], resolve),
    TrackPay = resolve => require(["@/views/trackPay/trackPay"], resolve),

    // Download documents
    DownloadReceivableDocuments = resolve => require(["@/views/user/downloadReceivableDocuments"], resolve)

;

Vue.use(VueRouter);

const routes = [{
    path: "/",
    component: DashboardLayout,
    redirect: navigationPaths.login.base,
    children: [{
            path: navigationPaths.register.base,
            component: RegisterLayer,
            children: [{
                    path: enumDef.signUpStep.path(enumDef.signUpStep.Language),
                    name: "SignUpPageLanguage",
                    component: SignUpPageLanguage,
                    meta: {
                        page: "register"
                    }
                },
                // {
                //     path: enumDef.signUpStep.path(enumDef.signUpStep.Invitation),
                //     name: "SignUpPageInvitation",
                //     component: SignUpPageInvitation,
                //     meta: {
                //         page: "register"
                //     }
                // },
                {
                    path: enumDef.signUpStep.path(enumDef.signUpStep.Company),
                    name: "SignUpPageCompany",
                    component: SignUpPageCompany,
                    meta: {
                        page: "register"
                    }
                },
                {
                    path: enumDef.signUpStep.path(enumDef.signUpStep.LegalData),
                    name: "SignUpPageLegalData",
                    component: SignUpPageLegalData,
                    meta: {
                        page: "register"
                    }
                },
                {
                    path: enumDef.signUpStep.path(enumDef.signUpStep.BankAccount),
                    name: "SignUpPageBankAccount",
                    component: SignUpPageBankAccount,
                    meta: {
                        page: "register"
                    }
                },
                {
                    path: enumDef.signUpStep.path(enumDef.signUpStep.MasterUser),
                    name: "SignUpPageMasterUser",
                    component: SignUpPageMasterUser,
                    meta: {
                        page: "register"
                    }
                },
                {
                    path: enumDef.signUpStep.path(enumDef.signUpStep.RepresentativeUser),
                    name: "SignUpPageRepresentativeUser",
                    component: SignUpPageRepresentativeUser,
                    meta: {
                        page: "register"
                    }
                },
                {
                    path: enumDef.signUpStep.path(enumDef.signUpStep.Representatives),
                    name: "SignUpPageRepresentatives",
                    component: SignUpPageRepresentatives,
                    meta: {
                        page: "register"
                    }
                },
                {
                    path: enumDef.signUpStep.path(enumDef.signUpStep.BeneficialOwners),
                    name: "SignUpPageBeneficialOwners",
                    component: SignUpPageBeneficialOwners,
                    meta: {
                        page: "register"
                    }
                },
                {
                    path: enumDef.signUpStep.path(enumDef.signUpStep.Password),
                    name: "SignUpPagePassword",
                    component: SignUpPagePassword,
                    meta: {
                        page: "register"
                    }
                },
                {
                    path: enumDef.signUpStep.path(enumDef.signUpStep.Overview),
                    name: "SignUpPageOverview",
                    component: SignUpPageOverview,
                    meta: {
                        page: "register"
                    }
                },
                {
                    path: enumDef.signUpStep.path(enumDef.signUpStep.Completion),
                    name: "SignUpPageCompletion",
                    component: SignUpPageCompletion,
                    meta: {
                        page: "register",
                        sidebar: "none"
                    }
                },
            ],
        },
        {
            path: navigationPaths.register.userActivation,
            component: NormalUserActivation,
            meta: {
                page: "register",
                sidebar: "none"
            }
        },
        {
            path: navigationPaths.login.base,
            component: Login,
            meta: {
                page: "login",
                sidebar: "none"
            }
        },
        {
            path: navigationPaths.accessDenied,
            component: AccessDenied,
        },
        {
            path: navigationPaths.redirect,
            component: Redirect,
            meta: {
                sidebar: "none"
            }
        },
        {
            path: navigationPaths.companyDisclosure,
            component: CompanyDisclosure,
            meta: {
                sidebar: "none"
            }
        },
        {
            path: navigationPaths.login.help,
            name: "SendEmail",
            component: SendEmail,
            meta: {
                sidebar: "none"
            }
        },
        {
            path: navigationPaths.admin.profile,
            name: "UserProfile",
            component: UserProfile,
            meta: {
                parent: "user"
            }
        },
        {
            path: navigationPaths.admin.users,
            name: "UserUsers",
            component: UserUsers,
            meta: {
                parent: "user"
            }
        },
        {
            path: navigationPaths.admin.accounts,
            name: "UserBankAccounts",
            component: UserBankAccounts,
            meta: {
                parent: "user"
            }
        },

        {
            path: navigationPaths.admin.company,
            name: "UserCompany",
            component: UserCompany,
            meta: {
                parent: "user"
            }
        },
        {
            path: navigationPaths.admin.invoices,
            name: "UserInvoices",
            component: UserInvoices,
            meta: {
                parent: "user"
            }
        },
        // {
        //     path: navigationPaths.dashboard,
        //     name: "Dashboard",
        //     component: Dashboard,
        //     meta: {
        //         parent: "dashboard"
        //     }
        // },
        {
            path: navigationPaths.seller.debtors,
            name: "debtorManagement",
            component: DebtorManagement,
            meta: {
                parent: "seller"
            }
        },
        // {
        //     path: navigationPaths.seller.sell,
        //     name: "SellerSell",
        //     component: SellerSell,
        //     meta: {
        //         parent: "seller"
        //     }
        // },
        // {
        //     path: navigationPaths.seller.upload,
        //     name: "SellerUpload",
        //     component: SellerUpload,
        //     meta: {
        //         parent: "seller"
        //     }
        // },
        // {
        //     path: navigationPaths.seller.putOptions,
        //     name: "SellerPutOption",
        //     component: SellerPutOption,
        //     meta: {
        //         parent: "seller"
        //     }
        // },
        {
            path: navigationPaths.seller.trackPay,
            name: "TrackPay",
            component: TrackPay,
            meta: {
                parent: "seller",
            }
        },
        // {
        //     path: navigationPaths.investor.exchange,
        //     name: "InvestorExchange",
        //     component: InvestorExchange,
        //     meta: {
        //         parent: "investor"
        //     }
        // },
        // {
        //     path: navigationPaths.investor.payments,
        //     name: "InvestorPayments",
        //     component: InvestorPayments,
        //     meta: {
        //         parent: "investor"
        //     }
        // },
        // {
        //     path: navigationPaths.investor.investments,
        //     name: "AllInvestments",
        //     component: AllInvestments,
        //     meta: {
        //         parent: "investor"
        //     }
        // },
        // {
        //     path: navigationPaths.investor.ratings,
        //     name: "CustomRating",
        //     component: CustomRating,
        //     meta: {
        //         parent: "investor"
        //     }
        // },
        {
            path: navigationPaths.login.resetPassword,
            name: "RestPasswords",
            component: RestPasswords,
            meta: {
                sidebar: "none"
            }
        },
        {
            path: navigationPaths.debtor.ipu,
            name: "DebtorIpu",
            component: DebtorIpu,
            meta: {
                parent: "debtor",
            }
        },
        {
            path: navigationPaths.debtor.trackPay,
            name: "TrackPay",
            component: TrackPay,
            meta: {
                parent: "debtor",
            }
        },
        {
            path: navigationPaths.download.receivableDocuments,
            name: "DownloadReceivableDocuments",
            component: DownloadReceivableDocuments,
            meta: {
                sidebar: "none"
            }
        }
    ]
}];

const router = new VueRouter({
    // mode: "history",
    routes,
});

navigationGuards.setupGlobal(router);

export default router;